module.exports = __webpack_public_path__ + "img/ring_y_0_1_null.1fee70d8.png";